import { Stack, Typography } from '@mui/material';
import type { ResourceType } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { ResourceTypeIndicator } from '@/components/cloudProviderIndicator';
import { MainDialog } from '@/components/dialogs/mainDialog';

export const SupportedResourceTypesText = ({
  resourceTypes,
}: {
  resourceTypes?: ResourceType[];
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Typography
        className='underline cursor-pointer'
        onClick={() => setIsOpen(true)}
      >
        {resourceTypes?.length} resource types
      </Typography>
      <MainDialog
        isOpen={isOpen}
        header={{
          title: 'Available Resource Types',
          onClose: () => setIsOpen(false),
        }}
        isLoading={false}
      >
        <Stack
          direction='column'
          flexWrap='wrap'
          gap='8px 100px'
          padding='24px 40px'
          maxHeight='400px'
          alignContent='flex-start'
        >
          {resourceTypes?.map((resourceType) => (
            <ResourceTypeIndicator
              key={resourceType}
              resourceType={resourceType}
            />
          ))}
        </Stack>
      </MainDialog>
    </>
  );
};
